
// Definición de defaults

export const defaultTipoJuicio: TipoJuicioProps = {
    idTipoJuicio:    0,
    descripcion:     '',
    activo:          false
};

// Creación de interfaces

export interface TipoJuicioProps {
    idTipoJuicio:    number;
    descripcion:     string;
    activo:          boolean;
}